import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    modalOpen: false,
    newTemplateOption: "Create an Empty Template", //default for example.
    newTemplateOptionTitle: "Create an Empty Template", //default for example.
    templateName: "",
    templateValid: false,
    copyTemplateTreeSelectedNode:"",
    DTDTemplateData:'',
    RepTemplateDetails:'',
    SelectedRepTemplate:'',
    SqlTemplateData:'',
    JSONTemplateData:'',
    DelimitedHeaderData:{FIELD_DELIMITER:encodeURIComponent(','),RECORD_DELIMITER:'CRLF'},
    XSDTemplateData:'',
    XMLTemplateData:'',
    EDISefTemplateData:'',
    isFormData:false,
    disableTree:false,
    generateHL7ACK:false,
    alertType:''
};

export const newTemplateSlice = createSlice({
  name: "newTemplate",
  initialState,
  reducers: {
    setNewTemplateOption: (state, action) => {
      state.newTemplateOption = action.payload;
    },
    setNewTemplateOptionTitle: (state, action) => {
      state.newTemplateOptionTitle = action.payload;
    },
    setTemplateName: (state, action) => {
      state.templateName = action.payload;
    },
    setModalOpen: (state, action) => {
      state.modalOpen = action.payload;
    },
    setTemplateValid: (state, action) => {
      state.templateValid = action.payload;
    },
    setCopyTemplateTreeSelectedNode:(state,action) =>{
      state.copyTemplateTreeSelectedNode = action.payload;
    },
    setDTDTemplateData:(state,action) =>{
      state.DTDTemplateData = action.payload
    },
    setRepTemplateDetails:(state,action) => {
      state.RepTemplateDetails = action.payload
    },
    setSelectedRepTemplate:(state,action) =>{
      state.SelectedRepTemplate = action.payload
    },
    setSqlTemplateData:(state,action) =>{
     state.SqlTemplateData = action.payload
    },
    setJSONTemplateData:(state,action) =>{
      state.JSONTemplateData = action.payload
    },
    setIsFormData:(state,action) =>{
     state.isFormData = action.payload
    },
    setDelimitedHeaderData:(state,action) =>{
      state.DelimitedHeaderData = action.payload 
    },
    setXSDTemplateData:(state,action) =>{
      state.XSDTemplateData = action.payload;
    },
    setXMLTemplateData:(state,action)=>{
      state.XMLTemplateData = action.payload;
    },
    setEDISefTemplateData:(state,action) => {
      state.EDISefTemplateData = action.payload
    },
    setDisableTree : (state,action) => {
      state.disableTree = action.payload
    },
    setShowAlert: (state,action) => {
      state.showAlert = action.payload
    },
    setAlertMessage: (state,action) => {
      state.alertMessage = action.payload
    },
    setAlertType : (state,action) => {
      state.alertType = action.payload
    },
    setGenerateHL7ACK : (state,action) => {
      state.generateHL7ACK = action.payload
    },
    resetState: (state) => {
      return initialState; // Reset to initial state
    },
    resetFields: (state) => {
      state.templateName = "";
      state.templateValid = false;
      state.copyTemplateTreeSelectedNode = "";
      state.DTDTemplateData = "";
      state.SelectedRepTemplate = "";
      state.SqlTemplateData = "";
      state.JSONTemplateData = "";
      state.DelimitedHeaderData = {
        FIELD_DELIMITER: encodeURIComponent(","),
        RECORD_DELIMITER: "CRLF",
      };
      state.XSDTemplateData = "";
      state.XMLTemplateData = "";
      state.EDISefTemplateData = "";
      state.isFormData = false;
      state.disableTree = false;
      state.generateHL7ACK = false;
    },

  },
});

export const newTemplateActions = {
  ...newTemplateSlice.actions,
};

export default newTemplateSlice.reducer;
